import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import Entities from 'STORE';

import { SEEN_TAB_NAME } from '../constants';

export const useTabsPresenter = ({ userReactionsList, userSeen, tab }) => {
  const presenter = useLocalObservable(() => ({
    tabs: [],
    selectedTab: null,
    userSeen: null,

    initTabs: (tabs) => {
      const tabList = tabs.filter((tab) => tab.list.length);

      presenter.tabs = tabList;
      presenter.setSelectedTab(tab || tabList[0]?.key || null);
    },

    setSelectedTab: (tab) => {
      presenter.selectedTab = tab;

      if (tab !== SEEN_TAB_NAME) {
        userReactionsList.selectedTab = tab;
        userReactionsList.cursor = 0;
        userReactionsList.updateCursor();
      }
    },

    get tabsList() {
      const reactionImages = Entities.reactionsStore.allReactions.reduce((acc, reaction) => {
        acc[reaction.id] = reaction.previewImage || reaction.previewURL;
        return acc;
      }, {});

      return presenter.tabs.map((tab) => {
        const { key, list } = tab;

        if (key === SEEN_TAB_NAME) {
          return {
            key: key,
            alt: key,
            list: presenter.userSeen,
            hasTitle: true,
            isActive: key === presenter.selectedTab,
            onClick: () => presenter.setSelectedTab(key),
          };
        }

        return {
          key: key,
          alt: key,
          path: reactionImages[key],
          onClick: () => presenter.setSelectedTab(key),
          isActive: key === presenter.selectedTab,
          counter: list.length,
          list: userReactionsList,
          isDisabled: list.isLoading,
        };
      });
    },

    get currentTab() {
      return presenter.tabsList.find((tab) => tab.key === presenter.selectedTab);
    },

    get hasTabs() {
      return presenter.tabsList.length >= 1;
    },

    setUserSeen(userSeen) {
      presenter.userSeen = userSeen;
    },
  }));

  useEffect(() => {
    presenter.setUserSeen(userSeen);
  }, [userSeen]);

  return presenter;
};
